import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white p-12 text-black font-simhei leading-relaxed toc-page-container" }
const _hoisted_2 = { class: "max-w-xl mx-auto space-y-1 text-base" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableOfContentsPage',
  props: {
  catalogs: {
    type: Array,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const getIndentClass = (level: number) => {
  if (level === 2) return 'pl-8';
  if (level === 3) return 'pl-16';
  return '';
};

const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

const flattenedCatalogs = computed(() => {
  const result: any[] = [];
  if (!props.catalogs) return result;

  props.catalogs.forEach((item: any, index: number) => {
    // Level 1
    const level1Title = `${chineseNumbers[index] || (index + 1)}、${item.title || item.label}`;
    result.push({ label: level1Title, level: 1, page:  Math.floor(Math.random() * 5) + 1 + index * 3 }); // Mock page numbers

    if (item.children) {
      item.children.forEach((child: any, childIndex: number) => {
        // Level 2
        const level2Title = `(${chineseNumbers[childIndex] || (childIndex + 1)}) ${child.title || child.label}`;
        result.push({ label: level2Title, level: 2, page: result[result.length - 1].page });

        if (child.children) {
            child.children.forEach((subChild: any, subIndex: number) => {
                 // Level 3 (Optional, maybe not shown in TOC or shown with deeper indent)
                 const level3Title = `${subIndex + 1}. ${subChild.title || subChild.label}`;
                  result.push({ label: level3Title, level: 3, page: result[result.length - 1].page });
            });
        }
      });
    }
  });
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-3xl text-center mt-16 mb-24 tracking-[1em] font-normal" }, "目录", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "toc-row" }, [
        _createElementVNode("span", null, "摘 要"),
        _createElementVNode("span", { class: "dots" }),
        _createElementVNode("span", null, "I")
      ], -1)),
      (__props.catalogs && __props.catalogs.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(flattenedCatalogs.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['toc-row', getIndentClass(item.level), index > 0 && item.level === 1 ? 'mt-4' : ''])
            }, [
              _createElementVNode("span", null, _toDisplayString(item.label), 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dots" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(item.page || ''), 1)
            ], 2))
          }), 128))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"toc-row mt-4\" data-v-62d19bc5><span data-v-62d19bc5>一、绪论</span><span class=\"dots\" data-v-62d19bc5></span><span data-v-62d19bc5>1</span></div><div class=\"toc-row pl-8\" data-v-62d19bc5><span data-v-62d19bc5>(一) 研究背景：基层治理与老年服务中老年教育的重要性凸显</span><span class=\"dots\" data-v-62d19bc5></span><span data-v-62d19bc5>1</span></div><div class=\"toc-row pl-8\" data-v-62d19bc5><span data-v-62d19bc5>(二) 研究意义：提升基层治理服务质量与促进老年教育发展</span><span class=\"dots\" data-v-62d19bc5></span><span data-v-62d19bc5>1</span></div>", 3))
          ], 64))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center mt-12" }, [
      _createElementVNode("span", null, "i")
    ], -1))
  ]))
}
}

})